import { ReactElement } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { TableContainer, Table, Thead, Th, Tbody, Tr, Td } from 'components/v2/Table'
import { Dropdown } from 'components/v2/Dropdown'
import { StyledLink } from 'components/v2/Link'
import List from 'components/v2/List'
import { FEATURES } from 'features/Roles/components/Permissions/constants'
import { VehicleTemplatesActions } from 'features/VehicleTemplates/views/Index/List/Actions'
import { vehicleTypeMessages } from 'features/VehicleTemplates/components/Type/messages'
import { canWrite } from 'features/Users/utils'
import { safeFormatMessage } from '@10xlabs/utils'
import { useLogin } from 'features/Login/hooks'
import { GTVehicleTemplate } from 'gql/types.generated'

interface IVehicleTemplatesListProps {
  vehicleTemplates: GTVehicleTemplate[]
  refetch: () => void
}

export const VehicleTemplatesList = ({ vehicleTemplates = [], refetch }: IVehicleTemplatesListProps): ReactElement => {
  const intl = useIntl()
  const login = useLogin()

  return (
    <TableContainer overflow>
      <Table marginBottom>
        <Thead>
          <Tr>
            {canWrite(FEATURES.VEHICLE_TEMPLATE, login.accessToken.policies) && <Th />}
            <Th>
              <FormattedMessage id="dictionary.name" defaultMessage="Name" />
            </Th>
            <Th>
              <FormattedMessage id="dictionary.type" defaultMessage="Type" />
            </Th>
            <Th>
              <FormattedMessage id="dictionary.capacity" defaultMessage="Capacity" />
            </Th>
            <Th>
              <FormattedMessage id="dictionary.vehicles" defaultMessage="Vehicles" />
            </Th>
            <Th>
              <FormattedMessage id="dictionary.companies" defaultMessage="Companies" />
            </Th>
          </Tr>
        </Thead>
        <Tbody>
          {vehicleTemplates.map((vehicleTemplate: TSFixMe): TSFixMe => {
            return (
              <Tr key={vehicleTemplate.id}>
                {canWrite(FEATURES.VEHICLE_TEMPLATE, login.accessToken.policies) && (
                  <Td>
                    <VehicleTemplatesActions vehicleTemplate={vehicleTemplate} refetch={refetch} />
                  </Td>
                )}
                <Td>{vehicleTemplate.name}</Td>
                <Td>{safeFormatMessage({ intl, messages: vehicleTypeMessages, key: vehicleTemplate.type })}</Td>
                <Td>{vehicleTemplate.capacity}</Td>
                <Td>{vehicleTemplate.vehicleIDs.length}</Td>
                <Td>
                  {vehicleTemplate.companies.length > 0 ? (
                    <Dropdown toggle={<StyledLink>{vehicleTemplate.companies.length}</StyledLink>} noPadding>
                      <List.Container>
                        {vehicleTemplate.companies.map(({ name, id }: TSFixMe): TSFixMe => {
                          return <List.Item key={id}>{name}</List.Item>
                        })}
                      </List.Container>
                    </Dropdown>
                  ) : (
                    0
                  )}
                </Td>
              </Tr>
            )
          })}
        </Tbody>
      </Table>
    </TableContainer>
  )
}
